import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Bell, Menu } from 'lucide-react'
import { settingsApi } from '../api'
import { useUIStore } from '../store'

const TITLES = {
  '/': 'Dashboard', '/dashboard': 'Dashboard', '/sales': 'Vendas',
  '/clients': 'Clientes', '/crm': 'CRM', '/whatsapp': 'WhatsApp',
  '/followup': 'Follow-Up', '/relationship': 'Relacionamento',
  '/nps-dashboard': 'NPS', '/financial': 'Financeiro', '/stock': 'Estoque',
  '/exchanges': 'Trocas', '/tasks': 'Tarefas', '/goals': 'Metas',
  '/ranking': 'Ranking', '/loyalty': 'Fidelidade', '/reports': 'Relatórios',
  '/ads': 'Anúncios', '/seller': 'Modo Vendedor',
  '/whatsapp-connect': 'Conexão WhatsApp', '/settings': 'Configurações',
}

export default function Header({ onMenuToggle, showMenuButton }) {
  const location = useLocation()
  const { alerts, setAlerts } = useUIStore()
  const [showAlerts, setShowAlerts] = useState(false)
  const unread = alerts.filter(a => !a.read).length

  useEffect(() => {
    settingsApi.alerts({ read: false }).then(r => setAlerts(r.data)).catch(() => {})
  }, [location.pathname])

  const title = TITLES[location.pathname] || 'ERP'

  return (
    <header className="h-14 bg-[#12121a] border-b border-[#2a2a3a] flex items-center justify-between px-4 md:px-6 flex-shrink-0 sticky top-0 z-20">
      <div className="flex items-center gap-3">
        {showMenuButton && (
          <button
            onClick={onMenuToggle}
            className="md:hidden p-2 rounded-lg hover:bg-[#1a1a26] text-[#6b6b80] hover:text-[#e8e8f0] transition-colors"
          >
            <Menu size={18} />
          </button>
        )}
        <h1 className="font-display font-bold text-lg text-[#e8e8f0]">{title}</h1>
      </div>

      <div className="flex items-center gap-2">
        <div className="relative">
          <button
            onClick={() => setShowAlerts(!showAlerts)}
            className="p-2 rounded-lg hover:bg-[#1a1a26] text-[#6b6b80] hover:text-[#e8e8f0] transition-colors relative"
          >
            <Bell size={16} />
            {unread > 0 && (
              <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 rounded-full text-[9px] text-white flex items-center justify-center font-bold">
                {unread > 9 ? '9+' : unread}
              </span>
            )}
          </button>

          {showAlerts && (
            <div className="absolute right-0 top-10 w-[calc(100vw-2rem)] max-w-[320px] bg-[#12121a] border border-[#2a2a3a] rounded-xl shadow-2xl z-50 overflow-hidden">
              <div className="px-4 py-3 border-b border-[#2a2a3a] flex items-center justify-between">
                <span className="text-sm font-semibold">Alertas</span>
                <span className="badge-red">{unread} novos</span>
              </div>
              <div className="max-h-72 overflow-y-auto">
                {alerts.length === 0 && (
                  <div className="px-4 py-6 text-center text-sm text-[#6b6b80]">Nenhum alerta</div>
                )}
                {alerts.slice(0, 10).map(alert => (
                  <div key={alert.id} className={`px-4 py-3 border-b border-[#2a2a3a]/50 hover:bg-[#1a1a26] transition-colors ${!alert.read ? 'border-l-2 border-l-red-500' : ''}`}>
                    <div className="text-xs font-medium text-[#e8e8f0]">{alert.title}</div>
                    {alert.message && <div className="text-[11px] text-[#6b6b80] mt-0.5">{alert.message}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
